export default __webpack_public_path__ + "static/about5-1b576387edb3804d2901c29b72b80bc6.jpg";